import { Checkbox, Empty, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import BasicInfoSection from './BasicInfoSection'
import AddressSection from './AddressSection'
import PaymentMethodSection from './PaymentMethodSection'
import IntakeFormSection from './IntakeFormSection'
import NoteSection from './NoteSection'
import AppointmentSection from './AppointmentSection'
import ChartSection from './ChartSection'
import FileSection from './FileSection'
import { useDispatch } from 'react-redux'
import { getCustomerDetails, getCustomerFiles } from 'services/guests.services'
import { setLoading } from 'redux/actions/app.actions'
import Spinner from 'components/Spinner/Spinner'
import { getAllAddresses } from 'services/addresses.service'
import GiftcardSection from './GiftcardSection'
import ProgramMembershipSection from './ProgramMembershipSection'
import FamilyReferralSection from './FamilyReferralSection'

export default function GuestDetails({ customerId, load = true,
    isPrimary,
    basicInforPreferences,
    onBasicInfoPreferenceChange,

    addresses: selectedAddresses,
    onAddressesChange,
    primaryAddress,
    onPrimaryAddressChange,
    files: selectedFiles, onFilesChange,

    onLoadGuestDetails,

}) {

    const [customerDetails, setCustomerDetails] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })

    const [addresses, setAddresses] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })

    const [paymentsInfo, setPaymentsInfo] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })
    const [charts, setCharts] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })
    const [notes, setNotes] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })
    const [orders, setOrders] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })
    const [giftcards, setGiftcards] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })
    const [programs, setPrograms] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })
    const [files, setFiles] = useState({
        data: null,
        isLoading: false,
        isFetched: false
    })


    const dispatch = useDispatch()
    useEffect(() => {
        const loadCustomerData = async () => {
            onLoadGuestDetails({
                userName: null,
                email: null,
                dob: null,
                flag: null
            })
            dispatch(setLoading(true))
            setCustomerDetails({
                data: null,
                isLoading: true,
                isFetched: false
            })
            const res = await dispatch(getCustomerDetails(customerId))

            dispatch(setLoading(false))
            setCustomerDetails(state => ({
                data: res?.status === 'success' ? res.data : null,
                isLoading: false,
                isFetched: true
            }))
            onLoadGuestDetails({
                userName: res?.data?.userName ?? null,
                email: res?.data?.email ?? null,
                dob: res?.data?.dob ?? null,
                flag: res?.data?.isCustomerProfileFlagged ?? null,
                firstName: res?.data?.firstName ?? null,
                lastName: res?.data?.lastName ?? null,
                phoneNumber: res?.data?.phoneNumber ?? null,
            })
        }

        const loadAddresses = async () => {

            const tempAddressIds = addresses.data?.map(address => address.addressId) ?? []


            setAddresses({
                data: null,
                isLoading: true,
                isFetched: false
            })
            const res = await dispatch(getAllAddresses(customerId, false))

            if (res?.status === 'success') {
                const data = res.data
                const addressIds = data.map(address => address.addressId)
                const primaryAddress = data.find(address => address.isPrimary === true)
                onAddressesChange(addressIds)
                if (isPrimary)
                    onPrimaryAddressChange(primaryAddress?.addressId)
            } else {
                onPrimaryAddressChange(state => {
                    if (tempAddressIds.includes(state)) {
                        return null
                    } else {
                        return state
                    }
                })
            }

            setAddresses({
                isLoading: false,
                isFetched: true,
                data: res?.status === 'success' ? res.data : null
            })
        }

        const loadFiles = async () => {
            setFiles({
                data: null,
                isFetched: false,
                isLoading: true
            })
            const res = await dispatch(getCustomerFiles(customerId))
            if (res?.status === 'success') {
                const documentIds = res?.data?.map(file => file.documentId)
                onFilesChange(documentIds)
            }
            setFiles({
                isLoading: false,
                isFetched: true,
                data: res?.status === 'success' ? res.data : null
            })

        }

        if (customerId && load) {
            // load all the data
            loadCustomerData()
            loadAddresses()
            loadFiles()
        } else {
            // reset everything
        }
    }, [customerId, load])


    function loadCustomerDetails() {

    }

    if (customerDetails?.isLoading) {
        return <Spinner />
    }
    if (customerDetails?.isFetched && !customerDetails) {
        return <Empty description="No data" />
    }

    return (
        <div>
            {/* Customer Info Section Start */}

            {/* Customer Info Section End */}
            <BasicInfoSection guest={customerDetails?.data ?? {}}
                isPrimary={isPrimary}
                basicInforPreferences={basicInforPreferences}
                onBasicInfoPreferenceChange={onBasicInfoPreferenceChange}
                customerId={customerId}
            />
            {/* Customer Addresses Section Start */}
            <AddressSection
                loading={addresses.isLoading}
                addresses={addresses.data ?? []}
                selectedAddresses={selectedAddresses}
                onAddressesChange={onAddressesChange}
                primaryAddress={primaryAddress}
                onPrimaryAddressChange={onPrimaryAddressChange}
                type={isPrimary ? "primary" : 'secondary'}
            />
            {/* Customer Addresses Section End */}


            {/* Customer Payment Methods Section Start */}
            <>
                <PaymentMethodSection />
                {/* <div>Payment Methods</div>
                <div>Will not be merged</div> */}
                {/* <div>
                    <Checkbox />
                    Payment Method
                </div>

                <div>
                    Mark as primary
                </div> */}
            </>
            {/* Customer Payment Methods Section End */}


            {/* Intake Forms Section Start */}
            <IntakeFormSection />
            {/* Intake Forms Section End */}

            {/* Notes Section Start */}
            <NoteSection />
            {/* Notes Section End */}

            {/* Appointments Section Start */}
            <AppointmentSection />
            {/* Appointments Section End */}

            {/* Charts Section Start */}
            <ChartSection />
            {/* Charts Section End */}


            {/* Files Section Start */}
            <FileSection
                loading={files.isLoading}
                files={files.data ?? []}
                selectedFiles={selectedFiles}
                onFilesChange={onFilesChange}
            />
            {/* Files Section End */}

            {/* Giftcard Section Start */}
            <GiftcardSection />
            {/* Giftcard Section End */}

            {/* Programs Section Start */}
            <ProgramMembershipSection />
            {/* Programs Section End */}

            {/* Family Members & Referals Section Start */}
            <FamilyReferralSection />
            {/* Family Members & Referals Section End */}
        </div>
    )
}